<template class="full-height">
  <div
    class="countries-latLng-components-app-container"
    style="position: relative; height: 100%; padding: 10px"
  >
    <div style="position: relative; height: 95%">
      <div>
        <el-form :inline="true" :model="form">
          <el-form-item>
            <el-button type="success" @click="addCity">新增</el-button>
          </el-form-item>

          <el-form-item label="區域" size="mini">
            <el-select
              v-if="regionsSource"
              v-model="form.region"
              value-key="key"
              placeholder="區域"
              size="mini"
              style="width: 100px"
              @change="selectedRegion(form)"
            >
              <el-option
                v-for="(c, ind) in regionsSource"
                :key="ind"
                :label="c.val"
                :value="c.key"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="國家" size="mini">
            <el-select
              v-if="form.countries"
              v-model="form.country"
              v-loading="form.countriesLoading"
              filterable
              placeholder="國家"
              value-key="code"
              size="mini"
              style="width: 200px"
              @change="selectedCountry(form)"
            >
              <el-option
                v-for="(c, ind) in form.countries"
                :key="ind"
                :label="c.chtName"
                :value="c"
              />
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="經緯度(lng,lat)">
            <el-col class="line" :span="12">
              <el-input v-model="item.lng" placeholder="經度(lng)" />
            </el-col>
            <el-col class="line" :span="12">
              <el-input v-model="item.lat" placeholder="緯度(lat)" />
            </el-col>
          </el-form-item> -->

          <!-- <el-form-item>
            <el-button type="danger" @click="deletePosition(item)"
              >刪除</el-button
            >
          </el-form-item> -->
          <!-- 
          <el-form-item>
            <el-button
              size="mini"
              @click="googleMap(item)"
              icon="el-icon-position"
              type="success"
              >查看Google地圖</el-button
            >
          </el-form-item> -->

          <el-form-item>
            <el-switch
              style="display: block"
              v-model="mode"
              :active-value="true"
              :inactive-value="false"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="開啟編輯"
              inactive-text="關閉編輯"
            >
            </el-switch>
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              style="cursor: pointer"
              :loading="listLoading"
              type="success"
              icon="el-icon-refresh-left"
              circle
              @click="refresh()"
            ></el-button>
          </el-form-item>
        </el-form>
      </div>

      <div>
        <el-alert
          style="margin: 10px"
          title="1，城市代碼：請輸入英文，單字間隔可輸入空白。2，城市名稱：不限中英文。"
          type="info"
          effect="dark"
          :closable="false"
        >
        </el-alert>

        <el-table
          v-loading="listLoading"
          size="mini"
          :data="form.cities"
          border
          fit
          highlight-current-row
          height="500px"
        >
          <!-- <el-table-column
          align="center"
          label="區域代碼"
          width="150"
          prop="value"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.value }}</span>
          </template>
        </el-table-column> -->

          <el-table-column align="left" label="城市代碼" width="180" prop="label">
            <template slot-scope="scope">
              <el-input size="mini" :disabled="!mode" v-model="scope.row.code"></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" label="城市名稱" width="150" prop="label">
            <template slot-scope="scope">
              <el-input size="mini" :disabled="!mode" v-model="scope.row.chtName"></el-input>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="首都" width="80" prop="label">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isCapital">是</el-tag>
          </template>
        </el-table-column> -->

          <el-table-column align="left" label="經緯度" width="600" prop="label">
            <template slot-scope="scope">
              <el-form :inline="true">
                <el-form-item label="北緯(lat)"
                  ><el-input size="mini" :disabled="!mode" v-model="scope.row.lat"></el-input
                ></el-form-item>
                <el-form-item label="東經(lng)"
                  ><el-input size="mini" :disabled="!mode" v-model="scope.row.lng"></el-input
                ></el-form-item>
              </el-form>
            </template>
          </el-table-column>

          <el-table-column align="center" label="設定" width="200">
            <template slot-scope="scope">
              <el-button v-if="mode" type="success" size="mini" @click="setCity(scope.row)"
                >設定</el-button
              >

              <el-button type="danger" size="mini" @click="deleteCity(scope.row)">刪除</el-button>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)"
              >編輯</el-button
            >
          </template>
        </el-table-column> -->
        </el-table>
      </div>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { getCountryRegions, getCountriesByRegion, getCitiesByCountryCode } from '@/api/travel'
import {
  getRegionArea,
  saveRegionAreaPosition,
  saveCurrencies,
  saveCity,
  deleteCity,
} from '@/api/system'

var defaultForm = {
  regions: [],
  countries: [],
  cities: [],
  lat: '',
  lng: '',
  citiesLoading: false,
  countriesLoading: false,
  passPointDialogVisible: false,
  description: '',
  region: '',
  country: null,
  city: null,
}

export default {
  name: 'CountriesSetting',
  props: {
    callback: {
      type: Function,
      default: () => null,
    },
  },
  watch: {},
  components: {
    Pagination,
  },
  data() {
    return {
      funcName: '區域管理',
      mode: false,
      dialogCurrencyVisible: false,
      currentRow: null,
      positionList: [],
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-Sort',
      },
      total: 0,
      list: [],
      regionsSource: [],
      currencyOptionList: [],
    }
  },
  async created() {
    this.form = defaultForm
    await this.getCountryRegions()
  },
  methods: {
    async refresh() {
      if (!this.form.country) {
        alert(`未選擇國家。`)
        return
      }
      await this.selectedCountry(this.form)
    },
    confirmCurrency(item) {
      console.log(this.currentRow)
    },
    async googleMap(row) {
      let lat = row.lat
      let lng = row.lng

      if (!lat || !lng) {
        alert('未輸入經緯度')
        return
      }
      let newWindow = window.open(`http://maps.google.com/?q=${lat},${lng}`)
      newWindow.opener = null
    },
    async deleteCity(event) {
      let hasID = event.id != null
      if (!confirm(`確定要刪除此城市?`)) {
        return
      }

      const vm = this
      try {
        this.listLoading = true
        if (hasID) {
          let resp = await deleteCity({ id: event.id })
          vm.callback('refreshTab1')
        }

        if (hasID) {
          vm.refresh()
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          vm.form.cities.splice(vm.form.cities.indexOf(event), 1)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
    async addCity() {
      const vm = this
      if (!vm.form.region || !vm.form.country) {
        alert(`請選擇區域及國家`)
        return
      }
      let emptyObj = {
        id: null,
        code: '',
        chtName: '',
        isCapital: false,
        lat: '',
        lng: '',
      }

      vm.form.cities.unshift(emptyObj)
    },
    async getCountryRegions() {
      const vm = this
      vm.regionsSource = []

      await getCountryRegions({}).then(response => {
        vm.regionsSource = response.data
      })
    },
    async setCity(row) {
      if (!confirm(`確定要儲存城市資料?`)) {
        return
      }
      let vm = this
      if (!row.code) {
        alet(`請輸入城市代碼。`)
        return
      }

      if (!row.chtName) {
        alet(`請輸入城市名稱。`)
        return
      }

      if (!row.lat) {
        alet(`請輸入座標北緯度。`)
        return
      }

      if (!row.lng) {
        alet(`請輸入座標東京度。`)
        return
      }

      let payload = JSON.parse(JSON.stringify(row))
      payload.countryID = vm.form.country.id

      try {
        vm.listLoading = true
        let resp = await saveCity(payload)
        vm.refresh()
        vm.callback('refreshTab1')
      } catch (error) {
        console.log(error)
      } finally {
        vm.listLoading = false
      }
    },
    async selectedRegion(data) {
      const vm = this
      data.country = null
      data.city = null
      data.countries = []
      data.cities = []
      vm.listLoading = true
      data.countriesLoading = true

      try {
        let resp = await getCountriesByRegion({ region: data.region })
        data.countriesLoading = false
        data.countries = resp.data
      } catch (error) {
        console.log(error)
      } finally {
        vm.listLoading = false
      }
    },
    async selectedCountry(data) {
      const vm = this
      data.city = null
      data.cities = []
      data.citiesLoading = true
      data.lat = data.country.lat
      data.lng = data.country.lng

      try {
        vm.listLoading = true
        let resp = await getCitiesByCountryCode({
          countryCode: data.country.code,
        })

        data.citiesLoading = false
        data.cities = resp.data
        data.cities.reverse()
      } catch (error) {
        console.log(error)
      } finally {
        vm.listLoading = false
      }
    },
    async selectedCity(data) {
      const vm = this
      data.lat = data.city.lat
      data.lng = data.city.lng
    },
    deletePlanning: function (event) {
      const vm = this
      vm.planningData.thisTime.data.splice(vm.planningData.thisTime.data.indexOf(event), 1)
    },

    addData() {
      this.dialogVisible = true
    },
    editData(row) {
      this.form = row
      this.dialogVisible = true
    },
    async saveCurrencies() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.currentRow.label}}】貨幣資料?`)) {
        return
      }

      if (!vm.currentRow) {
        alert(`請選擇國家或城市。`)
        return
      }

      let payload = {
        id: vm.currentRow.id,
        codes: vm.currentRow.currenciesCode,
      }

      if (vm.currentRow.currenciesCode.length == 0) {
        payload.codes = []
      }

      try {
        vm.dialogLoading = true
        let resp = await saveCurrencies(payload)
        vm.dialogCurrencyVisible = false
        await vm.getList()
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        vm.dialogLoading = false
      }
    },
    async savePosition() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.currentRow.label}}】經緯度資料?`)) {
        return
      }

      let validate = true
      let positions = []
      vm.positionList.forEach((f, index) => {
        if (!f.region) {
          alert(`第${index + 1}筆，未選擇區域。`)
          validate = false
        }

        if (!f.country) {
          alert(`第${index + 1}筆，未選擇國家。`)
          validate = false
        }

        positions.push({
          region: f.region,
          country: f.country,
          city: f.city,
          lat: f.lat,
          lng: f.lng,
        })
      })

      if (!validate) {
        return
      }

      let payload = {
        id: vm.currentRow.id,
        positionList: positions,
      }
      try {
        vm.dialogLoading = true
        let resp = await saveRegionAreaPosition(payload)
        vm.dialogVisible = false
        await vm.getList()
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        vm.dialogLoading = false
      }
    },
    async getList() {
      this.listLoading = true
      try {
        let resp = await getRegionArea(this.listQuery)

        // resp.data.data.forEach((f) => {
        //   f.hasChildren = true;
        // });

        this.list = resp.data
        console.log(this.list)
        this.total = this.list.length
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
  },
}
</script>

<style scoped>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.currency-select .el-tag.el-tag--info {
  background-color: green !important;
  border-color: black !important;
  color: white !important;
  font-size: 17px !important;
  height: 30px !important;
}

/deep/:disabled {
  color: blue !important;
}
</style>
